
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { DragulaService } from 'ng2-dragula/ng2-dragula';
import { Subscription } from 'rxjs/Subscription';

export abstract class ListComponentBase {
  private _outSubscription: Subscription;

  constructor(protected snackBar: MatSnackBar, protected dragulaService: DragulaService) { }

  protected _initSubscriptions() {
    this.outSubscription = this.dragulaService.out.subscribe(this.onOut.bind(this));
  }

  protected _dropSubscriptions() {
    this.outSubscription = null;
  }

  abstract get bagName(): string;

  abstract onSubmit();

  private set outSubscription(value: Subscription) {
    if (this._outSubscription) {
      this._outSubscription.unsubscribe();
    }

    this._outSubscription = value;
  }

  private onOut(value) {
    if (value[0] === this.bagName) {
      this.onSubmit();
    }
  }

  protected openSnackBar(message: string, action?: string, config?: MatSnackBarConfig) {
    config = Object.assign(new MatSnackBarConfig(), config, { duration: 3000 });
    this.snackBar.open(message, action, config);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/base/list-component-base.ts